export default __webpack_public_path__ + "static/media/E-Valuate-sm.368d9e3b.png";